import {Injectable} from '@angular/core';
import {SwPush} from '@angular/service-worker';
import {CommonService} from './common.service';
import {ToastMessagesService} from './toast-messages.service';

@Injectable({
  providedIn: 'root'
})
export class PushNotificationService {
  private readonly publicKey = 'BHMDCogtUl9Pai91baGIiPJBHuKwNma4e7-Rxg5pWmDxbktn_LxO154FWBWat1D_0wHSE9zcDN1pnzoFmHgRD3E';

  constructor(private swPush: SwPush, public toastMessagesService: ToastMessagesService, private commonService: CommonService) {
  }

  async pushSubscription(userId: number) {

    this.swPush.requestSubscription({
      serverPublicKey: this.publicKey
    })
      .then(async (sub) => {
        const subscription = JSON.stringify(sub);
        const insertModel = {
          userId,
          subscription
        };
        console.log(insertModel);
        await this.commonService.insertItem('people/subscription', insertModel);
      })
      .catch(err => {
          console.log('subscription error');
      });

  }
}
